<template>
  <div id="addRole" v-loading="isLoging">
    <el-dialog title="添加角色" width="40%" top="2rem" :close-on-click-modal="false" :visible.sync="showDialog"
      :destroy-on-close="true" @close="close()">
      <div id="shared" style="margin-right: 20px;">
        <el-form ref="roleForm" :model="formData" :rules="rules" status-icon label-width="80px">
          <el-form-item label="角色名称" prop="roleName">
            <el-input v-model="formData.roleName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="权限" prop="authority">
            <el-select v-model="formData.authority" multiple placeholder="请选择权限" style="width: 100%">
              <el-option v-for="item in authorityOptions" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <div style="float: right;">
              <el-button type="primary" @click="onSubmit">保存</el-button>
              <el-button @click="close">取消</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "addRole",
  props: {},
  computed: {},
  created() {
    this.getAllAuthority();
  },
  data() {
    return {
      formData: {
        roleName: null,
        authority: []
      },
      authorityOptions: [],
      loading: false,
      listChangeCallback: null,
      showDialog: false,
      isLoging: false,
      rules: {
        roleName: [
          { required: true, message: '请输入角色名称', trigger: ['blur'] },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: ['blur'] }
        ],
        authority: [
          { required: true, message: '请选择权限', trigger: 'change' }
        ]
      },
    };
  },
  methods: {
    openDialog: function (callback) {
      this.listChangeCallback = callback;
      this.showDialog = true;
    },
    onSubmit: function () {
      this.$refs.roleForm.validate((valid) => {
        if (valid) {
          this.isLoging = true;
          this.$axios({
            method: 'post',
            url: "/api/role/add",
            params: {
              name: this.formData.roleName,
              authority: this.formData.authority.join(',')
            }
          }).then((res) => {
            this.isLoging = false;
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: '添加成功',
                type: 'success'
              });
              this.showDialog = false;
              this.listChangeCallback();
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              });
            }
          }).catch((error) => {
            this.isLoging = false;
            console.error(error);
          });
        } else {
          return false;
        }
      });
    },
    close: function () {
      this.showDialog = false;
      this.formData.roleName = null;
      this.formData.authority = [];
    },
    getAllAuthority: function () {
      this.loading = true;
      this.$axios({
        method: 'get',
        url: "/api/authority/all"
      }).then((res) => {
        this.loading = false;
        if (res.data.code === 0) {
          this.authorityOptions = res.data.data;
          console.log(this.authorityOptions);
        }
      }).catch((error) => {
        this.loading = false;
        console.error(error);
      });
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/dialog/addRole.vue